import RenderIf from './render-if/Renderif';
import useMedicalSummaryLoadingPercentage from '../hooks/useMedicalSummaryLoadingPercentage';
import MedicalViewSummaryModal from './ui-control/MedicalViewSummaryModal';
import MedicalSummaryBtns from './ui-control/MedicalSummaryBtns';

// A Stone section like the rest of the form, not the Ocean block the old brand used.
const summarySectionClasses =
    'rounded-lg bg-surface-alt p-6 min-h-18 max-h-30 mb-2 ' +
    'overflow-hidden flex flex-col';

const genTextClasses =
    "flex justify-between items-center text-content max-h-full overflow-hidden shrink " +
    "[&>span]:text-xl [&>span]:font-['Open_Sans'] [&>span]:font-semibold";

const genTextContentClasses =
    "flex gap-2 max-h-full overflow-hidden items-center shrink " +
    "[&_button]:max-h-full [&_button]:shrink";

const customBarClasses = 'mt-6';

// Ocean fill on a pale Sand trail, both reading against the Stone panel.
const progressTrackClasses =
    'flex w-100 h-2 overflow-hidden rounded-md bg-accent-surface';

const progressBarClasses =
    'flex flex-col justify-center overflow-hidden text-center ' +
    'whitespace-nowrap transition-[width] duration-[600ms] ease-in-out ' +
    'bg-primary';

const MedicalSummarySection = () => {
    const {
        isPreProcessRecordLoading,
        summaryLoadingPercentage
    } = useMedicalSummaryLoadingPercentage();

    return (
        <>
            <div className={`${summarySectionClasses} mt-12! mb-4!`}>
                <div className={genTextClasses}>
                    <span className="font-bold">Medical Summary</span>
                    <RenderIf shouldRender={isPreProcessRecordLoading}>
                        <div className={customBarClasses}>
                            <div className="flex items-center gap-1">
                                {`${summaryLoadingPercentage || 0}%`}
                                <div className={progressTrackClasses}>
                                    <div
                                        className={progressBarClasses}
                                        role="progressbar"
                                        style={{ width: `${summaryLoadingPercentage || 0}%` }}
                                        aria-valuenow={summaryLoadingPercentage || 0}
                                        aria-valuemin="0"
                                        aria-valuemax="100"
                                    />
                                </div>
                            </div>
                            <small className="m-1 text-subtle">Generating medical summary can take 5 to 15 minutes...</small>
                        </div>
                    </RenderIf>
                    <div className={genTextContentClasses}>
                        <MedicalSummaryBtns />
                    </div>
                </div>
            </div>
            <MedicalViewSummaryModal />
        </>
    )
}

export default MedicalSummarySection;